import React from 'react';

import { createRoot } from 'react-dom/client';

import Femtasy from 'containers/Femtasy';

import registerServiceWorker from 'sw/register';

const VITE_PRELOAD_RETRY_KEY = 'vite:preloadError:retry';

const shouldReloadAfterVitePreloadError = () => {
  try {
    if (window.sessionStorage.getItem(VITE_PRELOAD_RETRY_KEY) === '1') {
      return false;
    }
    window.sessionStorage.setItem(VITE_PRELOAD_RETRY_KEY, '1');
    return true;
  } catch {
    return false;
  }
};

window.addEventListener('vite:preloadError', () => {
  if (shouldReloadAfterVitePreloadError()) {
    window.location.reload();
  }
});

// eslint-disable-next-line no-console
registerServiceWorker().catch(console.warn);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<Femtasy />);
